import CartIcon from "~/assets/icons/CartIcon"
import FacebookIcon from "~/assets/icons/FacebookIcon"
import InstagramIcon from "~/assets/icons/InstagramIcon"
import LinkedinIcon from "~/assets/icons/LinkedinIcon"
import Logo from "~/assets/icons/Logo"
import MailHeader from "~/assets/icons/MailHeader"
import PhoneHeader from "~/assets/icons/PhoneHeader"
import PinterestIcon from "~/assets/icons/PinterestIcon"
import SearchIcon from "~/assets/icons/SearchIcon"
import TwitterIcon from "~/assets/icons/TwitterIcon"
import UserIcon from "~/assets/icons/UserIcon"
import VisitHeader from "~/assets/icons/VisitHeader"
import YoutubeIcon from "~/assets/icons/YoutubeIcon"
import { CartDrawer } from "~/rs-components/global/CartDrawer.client"
import Navigation from "~/rs-components/global/navigation/Navigation.client"
import TrustPilotManagement from "~/rs-components/home/TrustPilotManagement.client"
import { CustomerMetafields } from "~/types"
import { header, contactInfo, trustPilotTop, trustPilotCustomSetting } from "../settings"
import { isNonTransactional } from "../settings/__nonTransactional"
import TrustPilotCustom from "./TrustPilotCustom.client"
import StoresIcon from "../assets/stores"
import LoginIcon from "../assets/login"
import BasketIcon from "../assets/basket"
import SuportIcon from "../assets/support"
import WishButtonIcon from "../custom_icons/WishButtonIcon"
import { wishlistButtonNextTitle, routeWishList } from "../settings/__product"
import TruspilotHeader from "./TruspilotHeader.client"
import CartBadge from "~/rs-components/global/header/CartBadge.client"
import UkIcon from "../assets/ukIcon"
import GuaranteeIcon from "../assets/guarantee"
import FinanceIcon from "../assets/fianance"
import { taglineSetup } from "./SetupActivityBar.client"


type SetupDesktopHeaderProps = {
    setShowCategory: React.Dispatch<React.SetStateAction<string | boolean>>,
    openCart: () => void,
    menuItems: any[]
    showCategory: string | boolean,
    shopSettings: string,
    customer?: CustomerMetafields,
}

export default function SetupDesktopHeader({ setShowCategory, openCart, showCategory, menuItems, shopSettings, customer }: SetupDesktopHeaderProps) {
    return (
        <>
            <div onMouseLeave={() => setShowCategory(false)} className="hidden lg:block top-0 z-50">
                <div className="header flex flex-row items-center px-8" onMouseEnter={() => setShowCategory(false)}>
                    {/* TODO: move image in assets image */}

                    <div className="logo">
                        <a className="aLogo" href="/">
                            <Logo />
                        </a>
                    </div>
                    <div className="customMenu">
                        <Navigation css={""} menuItems={menuItems} showCategory={showCategory} setShowCategory={setShowCategory} shopSettings={shopSettings} />
                    </div>
                </div>
            </div>

            <div className="subMenu">
                <div className="subMenu__container">
                    <div className="subMenu__item lineGrey trustPilot">
                        <TruspilotHeader />
                    </div>
                    <div className="subMenu__item lineGrey madeUK">
                        <a href="/page/made-in-the-uk">
                        <UkIcon/>
                            <p>Made in the UK*</p>
                        </a>
                    </div>

                    <div className="subMenu__item lineGrey frameGuarantee">
                        <a href="/page/guarantee">
                            <GuaranteeIcon/>
                            <p>10-year Frame Guarantee</p>
                        </a>
                    </div>

                    <div className="subMenu__item lineGrey financeAvailabe">
                        <a href="/page/finance">
                            <FinanceIcon/>
                            <p>Finance Available</p>
                        </a>
                    </div>

                    <div className="subMenu__item contactPhone">
                        <SuportIcon/>
                        <p>0330 124 4736</p>
                    </div>
                </div>


            </div >

        </>
    )
}